import api from './client';

export interface UserGroup {
  id: string;
  name: string;
  member_count: number;
  created_at: string | null;
}

export interface UserGroupMember {
  user_id: string;
  email: string;
  name?: string | null;
  created_at: string | null;
}

// 租户分组（部门雏形）：仅团队空间上下文可用（服务端按激活租户自动切换，请求不带租户参数）
export const groupsApi = {
  list: () => api.get<UserGroup[]>('/api/v1/groups').then((r) => r.data),
  create: (name: string) => api.post<UserGroup>('/api/v1/groups', { name }).then((r) => r.data),
  rename: (groupId: string, name: string) =>
    api.patch<UserGroup>(`/api/v1/groups/${groupId}`, { name }).then((r) => r.data),
  remove: (groupId: string) => api.delete(`/api/v1/groups/${groupId}`).then((r) => r.data),
  listMembers: (groupId: string) =>
    api.get<UserGroupMember[]>(`/api/v1/groups/${groupId}/members`).then((r) => r.data),
  addMember: (groupId: string, userId: string) =>
    api.post<UserGroupMember>(`/api/v1/groups/${groupId}/members`, { user_id: userId }).then((r) => r.data),
  removeMember: (groupId: string, userId: string) =>
    api.delete(`/api/v1/groups/${groupId}/members/${userId}`).then((r) => r.data),
};
